import { welcomeMessage, type DefaultWelcomeInput } from "@sagot/constants";
import type { components } from "@sagot/api-client";

type WidgetOut = components["schemas"]["WidgetOut"];

export interface AgentGreeting {
  /** First assistant bubble: the configured welcome message, else the default. */
  message: string;
  /** Starter questions shown as chips under the greeting. */
  starters: string[];
}

/**
 * What the Playground shows as the opening bubble, from the agent's widget draft (the same
 * welcome message and starter questions visitors get once published). UI-only: never sent to the
 * model and never part of the test conversation. Without widget access the default greeting shows.
 */
export function agentGreeting(widget: WidgetOut | undefined, fallback: DefaultWelcomeInput): AgentGreeting {
  const content: Record<string, unknown> = widget?.draft.content ?? {};
  const raw = content.starter_questions;
  const starters = Array.isArray(raw) ? raw.filter((q): q is string => typeof q === "string" && q.trim() !== "") : [];
  return { message: welcomeMessage(content.welcome_message, fallback), starters };
}
